import React, { useState } from 'react';
import './App.css';
import SpeechPractice from './components/SpeechPractice';
import Metrics from './components/Metrics';

function App() {
  const [currentPage, setCurrentPage] = useState('practice'); // 'practice' or 'metrics'

  return (
    <div className="App">
      {currentPage === 'practice' && (
        <SpeechPractice
          onNavigateToMetrics={() => setCurrentPage('metrics')}
        />
      )}
      {currentPage === 'metrics' && (
        <Metrics onBack={() => setCurrentPage('practice')} />
      )}
    </div>
  );
}

export default App;

